<template>
    <div :class="['block-monkey', container_class]" :style="{ 'background-image': 'url( ' + image + ' )' }">
        <div :class="['row-elements', sub_class]">
            <div class="container">
                <div class="row">
                    <div class="content">
                        <div v-html="text" />
                        <a
                            class="btn default"
                            v-if="link_label"
                            v-bind:href="link_url"
                        >{{link_label}}</a>
                        <a
                            class="btn default"
                            v-if="extra_link_label"
                            v-bind:href="extra_link_url"
                        >{{extra_link_label}}</a>

                        <button
                            v-if="button_video_true"
                            class="btn default show-modal"
                            id="show-modal"
                            @click="showModal = true"
                            v-html="video_button_title"
                        ></button>

                        <modal v-if="showModal" @close="showModal = false">
                            <div slot="content">
                                <div class="videoWrapper">
                                    <iframe
                                        :src="videosrc"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen
                                    ></iframe>
                                </div>
                            </div>
                        </modal>
                    </div>
                </div>
            </div>
        </div>
		<div class="hero-caption"><em>{{ image_caption }}</em></div>
    </div>
</template>

<script>
import Modal from "../components/Modal.vue";

export default {
    props: ["blockdata"],
    name: "block-monkey",
    data() {
        return {
            text: this.blockdata.text,
            image: this.blockdata.background_image.url,
            image_caption: this.blockdata.background_image_caption,
            link_url:
                this.blockdata.button_link && this.blockdata.button_link.url,
            link_label:
                this.blockdata.button_link && this.blockdata.button_link.title,
            extra_link_url:
                this.blockdata.button_extra_link &&
                this.blockdata.button_extra_link.url,
            extra_link_label:
                this.blockdata.button_extra_link &&
                this.blockdata.button_extra_link.title,
            button_video_true: this.blockdata.button_video,
            videosrc: this.blockdata.button_video.url,
            video_button_title: this.blockdata.button_video.title,
            sub_class: this.blockdata.class,
            container_class: this.blockdata.container_class,
            showModal: false
        };
    },
    components: {
        Modal
    },
    mounted: function() {}
};
</script>



// WEBPACK FOOTER //
// BlockMonkey.vue?c61345d6